<script>
  import {getContext} from 'svelte';
  import {selectChannel, selectedChannelId} from "./channelStore";
  import _ from 'lodash';
  import Emoji from "./Emoji.svelte";

  export let channel;
  export let darkTheme = false;

  // TODO: need to consider to move it. Not sure if it's a good architecture that this component calls closeDrawer function
  const closeDrawer = getContext('closeDrawer');

  const onClick = () => {
    selectChannel(channel);
    closeDrawer && closeDrawer();
  };


</script>


<div on:click={onClick} class="row item align-center clickable" class:dark={darkTheme} class:selected={$selectedChannelId === _.get(channel, 'id')}>
  <flex center class="icon">
      {#if channel.data().emoji}
        <div class="emoji">
          <Emoji emoji={channel.data().emoji}/>
        </div>
      {:else}
        <ion-icon name="scan-outline"></ion-icon>
      {/if}
  </flex>
    {channel.data().name}
</div>


<style>
  .item {
    padding: 0 4px;
    height: 40px;
    cursor: pointer;
  }

  .item.selected {
    color: white;
    background-color: black;
  }

  .icon {
    width: 32px;
  }

  .dark {
    background-color: black;
    color: white;
  }

  .dark.item.selected {
    color: black;
    background-color: white;
  }
</style>

